exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-aedddca8] .el-collapse-item__content{padding:0}[data-v-aedddca8] .el-tree{background:#0b3e4f;color:#fff}.dialog[data-v-aedddca8]{left:720px;top:300px;width:420px;height:220px}", ""]);

// exports
